import { render, staticRenderFns } from "./AddBodyDiagramModal.vue?vue&type=template&id=be0dbbf6"
import script from "./AddBodyDiagramModal.vue?vue&type=script&lang=js"
export * from "./AddBodyDiagramModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports